import { useQuery } from '@common-fe/common-fe';
import { CardTypesEnum, FiservCardPurse, FiservCardPurseStatusEnum } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const GET_CARDS_PURSES_KEY = 'GET_CARDS_PURSES_KEY';

const useGetCardsPursesQuery = (id?: string) => {
  const { isLoading, isError, isSuccess, data } = useQuery(
    [GET_CARDS_PURSES_KEY, id],
    () =>
      api.get(API_URL.CARD_PURSES, {
        params: { employee_id: id },
      }),
    {
      enabled: !!id,
      retry: false,
    }
  );

  const formattedData: FiservCardPurse[] =
    data?.data?.map(
      (item): FiservCardPurse => ({
        id: _.toString(item.id),
        accountName: item.account_name || '',
        accountType: item.account_type as CardTypesEnum,
        status: item.status as unknown as FiservCardPurseStatusEnum,
        isLockedByHealthPlan: !!item.is_locked_by_health_plan,
      })
    ) || [];

  return {
    formattedData,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetCardsPursesQuery;
